const footerLinks = {
  Systems: [
    { label: 'Operational Intelligence', href: '#solution' },
    { label: 'Decision Infrastructure', href: '#solution' },
    { label: 'Revenue Capture', href: '#solution' },
    { label: 'Execution Monitoring', href: '#solution' },
  ],
  Industries: [
    { label: 'Healthcare', href: '#industries' },
    { label: 'Construction', href: '#industries' },
    { label: 'Financial Services', href: '#industries' },
    { label: 'Lending & Advisory', href: '#industries' },
  ],
  Company: [
    { label: 'Our Process', href: '#process' },
    { label: 'Outcomes', href: '#cta' },
    { label: 'Consultation', href: '#cta' },
  ],
};

const scrollTo = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0C] border-t border-[#252528]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Main footer */}
        <div className="py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="/" className="inline-flex cursor-pointer mb-6 block">
              <img
                src="https://public.readdy.ai/ai/img_res/8f079269-9846-4254-b539-3b8eb1ff252a.png"
                alt="Auditore AI"
                className="w-[150px] h-[150px] object-contain"
                style={{ filter: 'drop-shadow(0 0 2px rgba(201,168,64,0.2))' }}
              />
            </a>
            <p className="text-[#96969E] text-sm leading-relaxed mb-8 max-w-xs">
              Structured intelligence systems for organizations where execution,
              compliance, and control matter most.
            </p>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-[#5BBFB5] text-sm"></i>
              </div>
              <span className="text-[#96969E] text-sm">contact@auditoreai.com</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-[#5BBFB5] text-sm"></i>
              </div>
              <span className="text-[#96969E] text-sm">United States</span>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-[#F2F0EC] text-xs font-bold mb-6" style={{ letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                {group}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollTo(link.href)}
                      className="text-[#96969E] text-sm hover:text-[#C9A840] transition-colors duration-200 cursor-pointer whitespace-nowrap text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider with gold accent */}
        <div className="relative h-px bg-[#252528]">
          <div className="absolute left-0 top-0 h-px w-32 bg-gradient-to-r from-[#C9A840]/50 to-transparent" />
        </div>

        {/* Bottom bar */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-[#3A3A3E] text-xs" style={{ letterSpacing: '0.08em' }}>
            &copy; {new Date().getFullYear()} Auditore AI. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            {['Privacy Policy', 'Terms of Service'].map((label) => (
              <span key={label} className="text-[#3A3A3E] text-xs hover:text-[#96969E] transition-colors cursor-pointer" style={{ letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
